import { render, staticRenderFns } from "./EditarClasificacionCompras.vue?vue&type=template&id=186df172"
import script from "./EditarClasificacionCompras.vue?vue&type=script&lang=js"
export * from "./EditarClasificacionCompras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports